/*
 * des-pickup-points.js — De Egaline Schuur afhaalpunten hover sync.
 *
 * Progressive enhancement for sections/des-pickup-points.liquid: hovering a map
 * pin highlights its list row and vice versa (the prototype's bidirectional
 * hover, 02 §nl-pickup-map). The page is fully usable without this script — it
 * only toggles an `is-active` class; it fetches nothing and adds no map library.
 *
 * Namespaced, no globals leaked. Safe to run more than once.
 */
(function () {
  "use strict";

  var CITY_ATTR = "data-des-pickup-city";
  var ACTIVE = "is-active";
  var BOUND = "desPickupBound";

  function setActive(nodes, on) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.toggle(ACTIVE, on);
    }
  }

  function init() {
    var els = document.querySelectorAll("[" + CITY_ATTR + "]");
    if (!els.length) {
      return;
    }

    // Group every element (pins + rows) by its shared city key.
    var byCity = {};
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var key = el.getAttribute(CITY_ATTR);
      if (!key) {
        continue;
      }
      (byCity[key] = byCity[key] || []).push(el);
    }

    Object.keys(byCity).forEach(function (key) {
      var group = byCity[key];
      group.forEach(function (el) {
        if (el.dataset[BOUND] === "1") {
          return;
        }
        el.dataset[BOUND] = "1";
        el.addEventListener("mouseenter", function () {
          setActive(group, true);
        });
        el.addEventListener("mouseleave", function () {
          setActive(group, false);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
